/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconButtonProps as MUIIconButtonProps} from '@material-ui/core/IconButton';
import {MaterialForwardIcon} from '../../icons/MaterialForwardIcon';
import {IconButton, IconButtonProps} from './IconButton';

export interface ForwardButtonProps extends Omit<MUIIconButtonProps, 'children' | 'color'>,
  Pick<IconButtonProps, 'controlButtonSize' | 'controlButtonPadding' | 'controlFrameSize' | 'controlIconSize'> {
  elementId?: string;
}

/**
 * Forward navigation control button rendered via the shared `IconButton`
 * control-button mode.
 *
 * ```typescript
 * import React from 'react';
 * import {ForwardButton} from '@ion/dls/src/components/buttons/ForwardButton';
 *
 * const Example = () => (
 *   <ForwardButton onClick={onForward} />
 * );
 * ```
 */
export const ForwardButton = ({
  controlButtonSize = 44,
  controlButtonPadding = 0,
  controlFrameSize = 24,
  controlIconSize = 24,
  ...props
}: ForwardButtonProps) => {
  return (
    <IconButton {...props}
      isControlButton
      controlButtonSize={controlButtonSize}
      controlButtonPadding={controlButtonPadding}
      controlFrameSize={controlFrameSize}
      controlIconSize={controlIconSize}
      icon={<MaterialForwardIcon />} />
  );
};

export default ForwardButton;
